module.exports = __webpack_public_path__ + "static/img/00016B_4_5_6_7_R_20200612_LC.c39a51a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00016B_4_5_6_7_R_20200612_LC.png
// module id = taIu
// module chunks = 0